import { _t } from '../base'

// const reviews = [
//     {
//         stars: 5,
//         name: 'Ověřený zákazník ',
//         reviewText: 'Supr rychlé doručení. Výborná komunikace obchodu. Můžu jen doporučit.',
//         date: '2024-03-15',
//         highlights: ['rychlé dodání', 'nízké ceny'],
//     },
//     {
//         stars: 5,
//         name: 'Ověřený zákazník frkotou ',
//         reviewText:
//             'Objednala jsem si šatní skříň a jsem nadšená. Perfektní komunikace, dodání přesně podle domluvy a kvalita odpovídá ceně. Jediné co bych vytkla je, že návod k sestavení mohl být detailnější. Přesto doporučuji!',
//         date: '2024-09-26',
//         highlights: ['zboží, které jinde není nebo za vyšší cenu', 'rychlé dodání'],
//     },
//     {
//         stars: 5,
//         name: 'Tomáš Novotný',
//         reviewText: 'Super.',
//         date: '2024-03-12',
//     },
//     {
//         stars: 4.5,
//         name: 'Lucie Černá',
//         reviewText:
//             'Koupili jsme kompletní vybavení do dětského pokoje. Nábytek vypadá přesně jako na fotkách, kvalita zpracování je výborná. Montáž zvládl manžel sám během víkendu. Děti jsou nadšené z barevného provedení.',
//         date: '2024-03-11',
//     },
//     {
//         stars: 5,
//         name: 'Jana Nováková',
//         reviewText: 'Výborná kvalita, dobrá cena.',
//         date: '2024-03-15',
//     },
//     {
//         stars: 4.5,
//         name: 'Martin Svoboda',
//         reviewText:
//             'Koupili jsme kuchyňskou linku na míru. Vše perfektně sedí, materiály jsou kvalitní. Oceňuji profesionální přístup při zaměření a následné montáži. Doporučuji!',
//         date: '2024-03-14',
//     },
//     {
//         stars: 4,
//         name: 'Petra Dvořáková',
//         reviewText: 'Spokojenost s nákupem, jen doprava trvala déle.',
//         date: '2024-03-13',
//     },
//     {
//         stars: 5,
//         name: 'Tomáš Novotný',
//         reviewText:
//             'Již podruhé jsme nakoupili v tomto obchodě a opět maximální spokojenost. Rychlé dodání, kvalitní zboží, bezproblémová komunikace.',
//         date: '2024-03-12',
//     },
//     {
//         stars: 4.5,
//         name: 'Lucie Černá',
//         reviewText: 'Nákup proběhl bez problémů, nábytek odpovídá popisu.',
//         date: '2024-03-11',
//     },
// ]

// Define the reviews array at the top level of the file
let reviews = []

async function fetchRatings() {
    try {
        const isSk = $('html[lang="sk"]').length
        const url = isSk ? '/hodnotenie-obchodu/' : '/hodnoceni-obchodu/'

        const response = await fetch(url)
        const html = await response.text()

        // Create a DOM parser to work with the HTML
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        // Find all review elements
        const reviewElements = doc.querySelectorAll('.vote-wrap')
        const newReviews = []

        // Process only the first 9 reviews with at least 3 stars
        let count = 0

        for (const reviewEl of reviewElements) {
            if (count >= 9) break

            // Get star rating
            const starsEl = reviewEl.querySelector('.stars')
            const starOnElements = starsEl.querySelectorAll('.star-on')
            const stars = starOnElements.length

            // Skip reviews with less than 3 stars
            if (stars < 3) continue

            // Get author name
            const nameEl = reviewEl.querySelector('[data-testid="textRatingAuthor"] span')
            const name = nameEl && nameEl.textContent.trim() ? nameEl.textContent.trim() : _t('reviews.name')

            // Get review text
            const textEl = reviewEl.querySelector('[data-testid="textRating"]')
            const reviewText = textEl ? textEl.textContent.trim() : ''

            // Get date
            const dateEl = reviewEl.querySelector('[data-testid="latestContributionDate"]')
            const dateText = dateEl ? dateEl.textContent.trim() : ''

            // Convert date from DD.MM.YYYY to YYYY-MM-DD
            let formattedDate = ''
            if (dateText) {
                const [day, month, year] = dateText.split('.')
                formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            }

            // Generate some highlights based on the review text
            const highlights = []
            if (reviewText.toLowerCase().includes('rýchl')) highlights.push('rýchle dodanie')
            if (reviewText.toLowerCase().includes('kvalit')) highlights.push('vysoká kvalita')
            if (reviewText.toLowerCase().includes('cen')) highlights.push('dobrá cena')
            if (reviewText.toLowerCase().includes('komunikáci')) highlights.push('výborná komunikácia')
            if (highlights.length === 0 && reviewText.length > 0) highlights.push('spokojnosť')

            newReviews.push({
                stars,
                name,
                reviewText,
                date: formattedDate,
                highlights,
            })

            count++
        }

        return newReviews
    } catch (error) {
        console.error('Error fetching ratings:', error)
        return []
    }
}

function createSlides() {
    const swiperWrapper = document.querySelector(`.able-ratings .swiper-wrapper`)
    const swiperNavigation = document.querySelector(`.able-ratings .swiper-navigation`)
    if (!swiperWrapper) return

    // Create slides from reviews
    reviews.forEach((review) => {
        const slide = document.createElement(`div`)
        slide.className = `swiper-slide ratings__item`

        const starsHtml = `
            <span class="stars star-list">
                ${[1, 2, 3, 4, 5]
                    .map(
                        (num) => `
                    <a class="star ${
                        num <= review.stars ? 'star-on' : num - 0.5 <= review.stars ? 'star-half' : 'star-off'
                    }"></a>
                `
                    )
                    .join(``)}
            </span>
        `

        slide.innerHTML = /* HTML  */ `
            <p class="review-date">
                ${new Date(review.date).toLocaleDateString('cs-CZ', {
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric',
                })}
            </p>
            ${starsHtml}
            <h4 class="reviewer-name">${review.name}</h4>
            ${
                review.highlights
                    ? `
                <ul class="review-highlights">
                    ${review.highlights.map((highlight) => `<li>${highlight}</li>`).join('')}
                </ul>
            `
                    : ''
            }
            <p class="review-text">${review.reviewText}</p>
        `

        swiperWrapper.appendChild(slide)
    })

    // Initialize Swiper
    new Swiper('.able-ratings .swiper', {
        slidesPerView: 1.5,
        spaceBetween: 10,
        navigation: {
            nextEl: '.able-ratings .swiper-button-next',
            prevEl: '.able-ratings .swiper-button-prev',
        },
        spaceBetween: 12,
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 4,
            },
            1399: {
                slidesPerView: 5,
                spaceBetween: 47,
            },
        },
        pagination: {
            el: '.able-ratings .swiper-pagination',
            type: 'progressbar',
        },
    })
}

export async function initRatings() {
    $('.data-placeholder').remove()

    // Fetch real reviews
    const fetchedReviews = await fetchRatings()

    // Use fetched reviews if available, otherwise use the default ones
    if (fetchedReviews.length > 0) {
        reviews.length = 0 // Clear the array
        fetchedReviews.forEach((review) => reviews.push(review))
    }

    createSlides()
}
